module.exports = __webpack_public_path__ + "img/move-closer-to-gateway.c4cb9.gif";